<script>
  const currentYear = new Date().getFullYear();
</script>

<footer>
  <div class="inner">
    <div class="brand"><a href="/">WIDELY</a><p>Business cards, organized.</p></div>
    <nav aria-label="Footer navigation">
      <a href="/#features">Features</a><a href="/business-card-scanner">Business Card Scanner</a>
      <a href="/business-card-organizer">Card Organizer</a><a href="/resources">Resources</a><a href="/support">Support</a>
      <a href="/privacy-policy">Privacy Policy</a><a href="/terms">Terms</a>
    </nav>
    <p class="copyright">© {currentYear} Widely Labs. All rights reserved.</p>
  </div>
</footer>

<style>
  footer{border-top:1px solid #262628;background:#080809}.inner{display:grid;grid-template-columns:1fr auto;width:min(100% - 40px,1240px);margin:auto;gap:58px 40px;padding:62px 0 34px}.brand a{color:#f5f5f0;font-size:1.05rem;font-weight:800;letter-spacing:.3em;text-decoration:none}.brand p,.copyright{margin:14px 0 0;color:#676763;font-size:.86rem}nav{display:flex;flex-wrap:wrap;justify-content:flex-end;gap:10px 28px}nav a{display:inline-flex;min-height:44px;align-items:center;color:#94948f;font-size:.86rem;text-decoration:none}nav a:hover{color:#f5f5f0}.copyright{grid-column:1/-1;padding-top:24px;border-top:1px solid #1f1f21}@media(max-width:720px){.inner{grid-template-columns:1fr;width:calc(100% - 32px);gap:34px}nav{display:grid;grid-template-columns:1fr 1fr;justify-content:start;gap:4px 22px}}
</style>
